import { render } from "./winBid.vue?vue&type=template&id=e6128ab8"
import script from "./winBid.vue?vue&type=script&lang=js"
export * from "./winBid.vue?vue&type=script&lang=js"

import "./winBid.vue?vue&type=style&index=0&id=e6128ab8&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__